/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_ListInputs */



/**
* | output |
* | --- |
* | "List" |
*
* @param {Markers_Export_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_list = /** @type {((inputs?: Markers_Export_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Liste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lista")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista")
	return /** @type {LocalizedString} */ ("List")
});